import PlanejamentoAcaoJustificativa from './PlanejamentoAcaoJustificativa.vue';

export default PlanejamentoAcaoJustificativa;
